<template>
    <div>
        <section class="padding-vertical-content" id="paso1" ref="paso1">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <h2 class="m-0 h1 text-uppercase">{{ !event.reserva_instalaciones ? $t('partido.selecciona_entradas') : $t('partido.selecciona_reservas') }}</h2>
                        <div class="subtitle h3 light mb-3 mb-lg-4 mb-lg-5">{{ !event.reserva_instalaciones ? $t('evento.elige_cantidad') : $t('evento.elige_cantidad_reservas') }}</div>
                        <div class="row" id="seleccionar-zona">
                            <div class="col-12 col-lg-8">
                                <EntradasSinRecintoComponent
                                    :puede_seleccionar="puede_seleccionar"
                                    :entradas="entradas"
                                    :event="event"
                                    v-on:actualizar="actualizar"
                                    :iva="event.experiencia ? footer.iva_experiencia : footer.iva_partido"
                                />
                            </div>
                            <div class="col-12 col-lg-4">
                                <div class="row">
                                    <div class="col-12">
                                        <DatosEntradasSinRecinto
                                            :entradas="entradas"
                                            :paso_activo="paso1_activo"
                                            :event="event"
                                            v-on:continuar="bloquearAsientos"
                                        />
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content" v-if="pasoProductos" key="pasoProductos" id="pasoProductos" ref="pasoProductos">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ListadoProductosComponent :productos="productosListado" :desactivar="!pasoProductos_activo"/>
                        </div>
                    </div>
                </div>
                <CarritoEvento
                    :carrito_id="carrito_id"
                    :entradas="entradas"
                    :loading="loading"
                    :productos="productos"
                    :productosListado="productosListado"
                    :desactivar="!pasoProductos_activo"
                    @terminar="finalizarPasoProductos"
                    @cambiar-asiento="cambiarAsiento"
                    :containerRef="containerRefs.pasoProductos"
                />
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="paso2" id="paso2" key="paso2" class="padding-vertical-content lightgray-content">
                <div class="container">
                    <DatosCompradoresComponent
                        :datos_compradores="datos"
                        :generos="generos"
                        v-on:terminar="guardarDatos"
                        :entradas="entradas"
                        :solicitar_datos="event.solicitar_datos"
                        :loading="loading"
                        :desactivar="paso3 ? true : false"
                        :fields="event.fields" :errors="errors"
                        :reserva_instalaciones="event.reserva_instalaciones"
                        :event="event"
                        @cambiar-asiento="cambiarAsiento"
                    />

                    <div class="row">
                        <div v-if="loading" class="col-12 text-center" style="margin-top: 100px; margin-bottom: 100px">
                            <LoaderComponent/>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
        <transition name="fade" mode="out-in">
            <section v-if="paso3" id="paso3" key="paso3" class="white-content padding-vertical-content">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <h2 class="m-0 h1 text-uppercase">{{ $t('partido.resumen_compra') }}</h2>
                            <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('partido.revisa_datos') }}</div>
                        </div>
                        <div class="col-12 col-lg-8">
                            <template v-for="entrada in entradas">
                                <ul :key="entrada.id" v-if="entrada.unidades && entrada.unidades > 0" class="resumen d-md-flex justify-content-between">
                                    <li class="altcolor-content">
                                        <div class="text-bold oswald text-uppercase m-0 w-100">
                                            1. {{ entrada.name }}
                                            <template v-if="event.reserva_instalaciones">
                                                ({{ event.fecha_sesion }})
                                            </template>
                                        </div>
                                    </li>
                                    <li>
                                        <label>{{ $t('general.precio') }}</label>
                                        <div class="h3 m-0 padding-mobile">{{ entrada.price | formatear_precio }}</div>
                                    </li>

                                    <li>
                                        <label>{{ $t(!event.reserva_instalaciones ? 'evento.numero_entradas' : 'evento.numero_reservas') }}</label>
                                        <div class="h3 m-0 padding-mobile">{{ entrada.unidades }}</div>
                                    </li>
                                    <li>
                                        <label>{{ $t('evento.total') }}</label>
                                        <div v-if="entradas[0].price_management_interno" class="h3 m-0">{{ entrada.unidades * entrada.price | formatear_precio }}</div>
                                        <div v-else class="h3 m-0 padding-mobile">{{ entrada.unidades * entrada.price | formatear_precio }}</div>
                                    </li>
                                </ul>
                            </template>

                            <template v-if="voucher">
                                <ul class="resumen d-md-flex justify-content-between">
                                    <li class="altcolor-content">
                                        <div class="text-bold oswald text-uppercase m-0 w-100">{{ $t("evento.voucher") }}</div>
                                    </li>
                                    <li>
                                        <label>{{ $t("evento.code") }}</label>
                                        <div>{{ voucher.code }}</div>
                                    </li>

                                    <li>
                                        <label>{{ $t("evento.discount") }}</label>
                                        <div>{{ voucher.discount_percent != 0 ? voucher.discount_percent + "%" : voucher.discount_fixed + "€" }}</div>
                                    </li>
                                    <li>
                                        <label>{{ $t('evento.total') }}</label>
                                        <div class="h3 m-0">{{ -voucher_discounted_total | formatear_precio  }}</div>
                                    </li>
                                </ul>
                            </template>

                            <ResumenProductos v-if="productos && productos.length > 0" :productos="productos"/>

                        </div>
                    </div>
                    <div class="col-12 col-lg-4">
                        <label>{{ $t('evento.total_pagar') }}</label>
                        <div class="price price-large gradient-color" v-if="entradas[0].price_management_interno">{{ total - voucher_discounted_total + calcularTotalProductos() | formatear_precio }}</div>
                        <div class="price price-large gradient-color resize" v-else>{{ envio_whatsapp ? (total_con_gd + parseFloat(coste_envio_whatsapp) - voucher_discounted_total + calcularTotalProductos()) : (total_con_gd - voucher_discounted_total + calcularTotalProductos()) | formatear_precio }}</div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-8 mt-4">
                            <CheckVoucherComponent class="mb-5" :event_id="event.id" :event_session_id="sesion_id" :cart_session_id="session_id" :loading="loading" @validated="setValidDiscountCode" />
                        </div>
                        <div class="col-12 col-lg-8">
                            <FormTerminos
                                :error="error"
                                @continuar="aceptarCondiciones"
                            />
                            <div v-if="teatro.hash == 'YM44GdDJCxMy5LrdJDms'" class="border border-danger rounded pb-0 pt-2 px-2 text-danger font-weight-bold mb-3" style="background-color: #fff0f0;">
                                <i class="fas fa-exclamation-triangle p-1 mb-2 fa-1x" style="font-size: 20px;">
                                    <b class="ml-1"> {{ $t('teatros.aviso_titulo') }}</b>
                                </i>
                                <p class="mb-1">-{{ $t('teatros.aviso_no_cambios') }}</p>
                                <p class="mb-2">-{{ $t('teatros.aviso_no_acceso') }}</p>
                            </div>
                        </div>
                        <div class="col-12 col-lg-8">
                            <div class="mt-4 mt-lg-2">
                                <b-row>
                                    <b-col cols="12">
                                        <ResumenPrecioComponent :price="(total + calcularTotalProductosSinManagement()) - voucher_discounted_total " :price_management="total_gd" :price_management_interno="entradas[0].price_management_interno" :iva="!event.experiencia ? footer.iva_experiencia : footer.iva_partido"/>
                                    </b-col>
                                    <b-col cols="12" class="mt-3">
                                        <button :disabled="procesar_precio_cero" @click.prevent="terminar" class="button large-button effect-button">
                                            <span
                                                v-if="total == 0"
                                                class="text-uppercase"
                                            >
                                                {{ $t("evento.descargar_entradas") }}
                                            </span>
                                            <span v-else class="text-uppercase">{{ $t("evento.continue") }}</span>
                                        </button>
                                    </b-col>
                                </b-row>
                            </div>
                            <SendFacebookPetition
                                v-if="pixel_id"
                                :evento_id="String(event.id)"
                                event_name="AddToCart"
                                :evento_name="event.name"
                                :nombre="datos.nombre"
                                :apellidos="datos.apellidos"
                                :email="datos.email"
                                :quantity="entradas.length"
                                :total="total_con_gd - voucher_discounted_total"
                                :url_evento="url"
                                :user_order="session_id"
                                :cp="datos.cp"
                            />
                        </div>
                        <template v-if="formulario != null" >
                            <div id="formulario-compra" v-html="formulario" v-show="false"></div>
                        </template>
                    </div>
                </div>
                <transition name="fade" mode="out-in">
                    <section class="padding-vertical-content lightgray-content" v-if="procesar_pago" key="pago" id="pago">
                        <div class="container">
                            <div class="row">
                                <div class="col-12">
                                    <h2 class="m-0 h1 text-uppercase">{{ $t('compra.confirmacion_compra') }}</h2>
                                    <div class="subtitle h3 light mb-3 mb-lg-5">{{ $t('compra.introduce_datos') }}</div>
                                    <PagoPaycometComponent
                                        ref="pago"
                                        tipo_venta="evento"
                                        :jet_id="jet_id"
                                        :session_id="session_id"
                                    />
                                </div>
                            </div>
                        </div>
                    </section>
                </transition>
            </section>
        </transition>
    </div>
</template>

<script>
    import EntradasSinRecintoComponent from '@/components/frontend/events/compra/EntradasSinRecintoComponent';
    import DatosEntradasSinRecinto from '@/components/frontend/events/compra/DatosEntradasSinRecinto';
    import DatosCompradoresComponent from '@/components/frontend/events/compra/DatosCompradoresComponent';
    import FormTerminos from '@/components/frontend/components/FormTerminos';
    import CheckVoucherComponent from '@/components/frontend/events/compra/CheckVoucherComponent';
    import SendFacebookPetition from "@/components/common/SendFacebookPetition";
    import ResumenPrecioComponent from "@/components/frontend/compra/components/ResumenPrecioComponent.vue";
    import PagoPaycometComponent from '@/components/frontend/compra/components/PagoPaycometComponent';
    import ListadoProductosComponent from './components/productos/ListadoProductosComponent.vue';
    import CarritoEvento from './components/CarritoEvento.vue';
    import ResumenProductos from './components/productos/ResumenProductos.vue';
    

    export default {
        props: ['event', 'sesion_id', 'tiempoTerminado'],
        data() {
            return {
                zonas: null,
                entradas: null,
                datos: {},
                formulario: null,
                session_id: null,
                carrito_id: null,
                terminos: false,
                newsletter: false,
                paso1_activo: true,
                pasoProductos: false,
                pasoProductos_activo: false,
                pasoProductos_loading: false,
                paso2: false,
                paso3: false,
                error: false,
                loading: false,
                puede_seleccionar: true,
                voucher: "",
                pixel_id: process.env.VUE_APP_PIXEL_ID,
                procesar_pago: false,
                procesar_precio_cero: false,
                jet_id: null,
                errors: null,
                envio_whatsapp: true,
                noTieneTelefono: false,
                isValidNumber: false,
                productos: [],
                productosListado: [],
                containerRefs: {
                    pasoProductos: null,
                },
                carritoHeights: {
                    pasoProductos: 0,
                },
            }
        },
        created() {
            this.entradas = this.event.entradas;
            this.iniciarCompra();
        },
        beforeDestroy() {
            if (this.procesar_pago) {
                this.$refs.pago.clearAllIntervals();
            }
        },
        watch: {
            tiempoTerminado(tiempoTerminado) {
                if (tiempoTerminado) {
                    this.reset();
                }
            },
            pasoProductos(newVal) {
                if (newVal) {
                    this.$nextTick(() => {
                        const container = this.$refs.pasoProductos;
                        if (container) {
                            this.containerRefs.pasoProductos = container;
                            const carrito = container.querySelector('.carrito-compras');
                            this.carritoHeights.pasoProductos = carrito ? carrito.offsetHeight : 0;
                        }
                    });
                } else {
                    this.containerRefs.pasoProductos = null;
                    this.carritoHeights.pasoProductos = 0;
                }
            }
        },
        computed: {
            coste_envio_whatsapp() {
                return parseFloat(this.teatro.coste_envio_whatsapp);
            },
            url() {
                return window.location.href;
            },
            total_con_gd() {
                let total = 0;
                if(this.entradas != undefined) {
                    for(let e in this.entradas) {
                        if(this.entradas[e].unidades > 0) {
                            total = total + (this.entradas[e].total_price * this.entradas[e].unidades);
                        }
                    }
                }

                return total;
            },
            total() {
                var total = 0;
                if(this.entradas != undefined) {
                    for(var e in this.entradas) {
                        if(this.entradas[e].unidades > 0) {
                            total = total + (this.entradas[e].price * this.entradas[e].unidades);
                        }
                    }
                }

                return total;
            },
            total_gd() {
                var total = 0;
                for(var i in this.entradas) {
                    if(this.entradas[i].unidades > 0) {
                        var gd = parseFloat(this.entradas[i].price_management) * this.entradas[i].unidades;

                        total = total + gd;
                    }
                }

                total = total += parseFloat(this.coste_envio_whatsapp);


                if (this.productos && this.productos.length > 0) {
                    total += this.productos.reduce((total, producto) => {
                        const priceManagement = producto.item.price_management_interno === 0 ? Number(producto.item.price_management) : 0;
                        return total + (priceManagement * producto.units);
                    }, 0);
                }

                return total;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            },
            voucher_discounted_total() {
                if(!this.voucher) return 0;

                var total = 0;
                var voucher_units = this.voucher.units;

                for(var entrada of this.entradas) {
                    if(voucher_units <= 0) break;

                    for(var unit = 0; unit < entrada.unidades; unit++) {
                        if(voucher_units <= 0) break;
                        voucher_units--;

                        if(this.voucher.discount_percent > 0) {
                            total += (this.voucher.discount_percent / 100) * parseFloat(entrada.price);
                        } else {
                            total += parseFloat(this.voucher.discount_fixed);
                        }
                    }
                }

                return total;

            },
            footer() {
                return this.$store.getters.getFooter;
            },
            teatro() {
                return this.$store.getters.getTeatro;
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        methods: {
            scrollTo(paso) {
                this.$scrollTo(paso, 100)
            },
            async iniciarCompra() {
                this.$nextTick(() => {
                    this.$refs.paso1?.scrollIntoView({ behavior: 'smooth' });
                });
            },
            terminar() {
                if (this.terminos && !this.noTieneTelefono) {
                    if (this.formulario) {
                        setTimeout(() => {
                            document.getElementById('btn-pagar').click();
                        }, 1000);
                    } else if (this.jet_id) {
                        this.procesar_pago = true;
                        this.$nextTick(() => {
                            this.scrollTo('#pago');
                        });
                    } else if (this.total == 0) {
                        this.procesar_precio_cero = true;
                        this.procesarCompraPrecioCero();
                    }
                } else {
                    this.error = true;
                }
            },
            bloquearAsientos() {
                this.loading = true;
                this.paso1_activo = false;
                this.puede_seleccionar = false;

                let params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    entradas: this.entradas
                }

                const cookie = this.$cookies.get('comunicados-track-id');

                if(cookie) {
                    params.token_comunicado = cookie;
                }

                this.$store.dispatch(this.config.getVuexAlias('front.bloquear.asientos'), params).then(res => {
                    if(res.data.error) {
                        this.$toast.error(res.data.message);
                        this.$router.go(this.$router.currentRoute);
                    } else {
                        this.carrito_id = res.data.cart_id;
                        if(this.event.tiene_productos) {
                            this.pasoProductos = true;
                            this.pasoProductos_activo = true;
                            this.$nextTick(() => {
                                this.scrollTo('#pasoProductos');
                            });
                        } else {
                            this.paso2 = true;
                            this.$nextTick(function() {
                                this.scrollTo('#paso2');
                            });
                        }

                        this.session_id = res.data.session_id;
                        sessionStorage.setItem('session_id', this.session_id);
                        this.loading = false;
                    }
                }).catch(error => {
                    this.$toast.error('Entradas agotadas.');
                    this.$router.go(this.$router.currentRoute);
                    console.log(error);
                    this.loading = false;
                });
            },
            finalizarPasoProductos() {
                this.loading = true;

                const tieneProductos = this.productosListado.length > 0 || (this.productos.length > 0 && this.productosListado.length > 0);
                let transformedProductos = [];

                if (!tieneProductos) {
                    this.pasoProductos_activo = false;
                    this.loading = false;
                    this.paso2 = true;
                    this.$nextTick(() => this.scrollTo('#paso2'));
                    return;
                }

                if (this.productos.length === 0 || this.productosListado.length === 0) {
                    transformedProductos = this.productosListado.map(product => ({
                        teatro_product_id: product.item.id,
                        event_id: this.$route.params.event_id,
                        event_session_id: this.$route.params.sesion_id,
                        units: product.units,
                    }));
                } else {
                    this.productosListadoCombinacion();
                    transformedProductos = this.productos.map(product => ({
                        teatro_product_id: product.item.id,
                        event_id: this.$route.params.event_id,
                        event_session_id: this.$route.params.sesion_id,
                        units: product.units,
                    }));

                    const params = {
                        filters: {
                            tid: this.configuracion.hash_teatro,
                        },
                        cart_id: this.carrito_id,
                    };

                    this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.productos.delete'), params);
                }

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                    },
                    cart_id: this.carrito_id,
                    productos: transformedProductos,
                };

                this.$store.dispatch(this.config.getVuexAlias('usuario.carrito.productos'), params)
                    .then(() => {
                        this.pasoProductos_activo = false;
                        this.productosListadoCombinacion();
                        this.$nextTick(() => {
                            this.loading = false;
                            this.paso2 = true;
                            this.$nextTick(() => this.scrollTo('#paso2'));
                        });
                    })
                    .catch(error => {
                        console.error('Error al añadir productos al carrito:', error);
                    });
            },
            guardarDatos(info_entradas) {
                this.loading = true;

                this.datos.asientos = info_entradas;

                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    datos_compradores: this.datos,
                    session_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.guardar.datos.comprador'), params).then(res => {
                    this.jet_id = res.data.jet_id;
                    this.formulario = res.data.formulario;
                    if (this.datos.telefono) {
                        this.isValidNumber = true;
                    }
                    this.paso3 = true;
                    this.$nextTick(function() {
                        this.scrollTo('#paso3');
                    });
                }).catch(error => {
                    if (error.response.data.message == 'Campos requeridos') {
                        this.errors = error.response.data.errors;
                    } else {
                        this.$toast.error(error.response?.data?.message);
                    }
                }).finally(() => this.loading = false);
            },
            guardarEnvioWhatsapp() {
                this.datos.envio_whatsapp = this.envio_whatsapp;

                if (!this.envio_whatsapp) {
                    this.guardarDatos();
                } else if (this.envio_whatsapp && this.isValidNumber) {
                    this.noTieneTelefono = false;
                    this.guardarDatos();
                } else {
                    this.noTieneTelefono = true;
                }
            },
            actualizar(siguiente) {
                this.loading = true;
                this.$emit('actualizarEntradas');
                this.$nextTick(function() {
                    this.siguiente = siguiente;
                    this.loading = false;
                });
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.guardarDatos();
                }
            },
            setValidDiscountCode(voucher) {
                this.datos.voucher = voucher;
                this.voucher = voucher;
                this.guardarDatos();
            },
            aceptarCondiciones(continuar, privacidad, condiciones, comunicaciones) {
                this.datos.privacidad = privacidad;
                this.datos.condiciones = condiciones;
                this.datos.comunicaciones = comunicaciones;
                if (continuar == true) {
                    this.guardarTerminosCondiciones();
                    this.terminos = true;
                } else {
                    this.terminos = false;
                }
            },
            reset() {
                if (this.procesar_pago) {
                    this.$refs.pago.clearAllIntervals();
                }
                this.$emit('reset');
            },
            procesarCompraPrecioCero() {
                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro
                    },
                    carrito_id: this.session_id
                }

                this.$store.dispatch(this.config.getVuexAlias('front.events.procesar-compra-precio-cero'), params).then(res => {
                    this.$router.push(`/compra/${this.session_id}/${res.data.n_pedido}`);
                }).catch(error => {
                    this.$router.push(`/compra/0/0`);
                }).finally(() => this.loading = false);
            },
            guardarTerminosCondiciones(){
                const params = {
                    filters: {
                        sesion_id: this.sesion_id,
                        tid: this.configuracion.hash_teatro
                    },
                    privacidad: this.datos.privacidad,
                    condiciones: this.datos.condiciones,
                    comunicaciones: this.datos.comunicaciones,
                    session_id: this.session_id,
                }
                this.$store.dispatch(this.config.getVuexAlias('front.guardar.terminos.condiciones'), params).catch(error => {
                    this.$toast.error('Error al guardar los terminos y condiciones');
                });
            },
            cambiarAsiento(dummy = null, productos = false) {
                if (productos) {
                    this.paso1_activo = true;
                    this.puede_seleccionar = true;
                    this.pasoProductos = false;
                    this.pasoProductos_activo = false;
                    this.productos = [];
                    this.productosListado = [];
                    this.$nextTick(() => {
                        this.scrollTo('#paso1');
                    });
                } else {
                    this.datos = {};
                    this.paso2 = false;
                    if (this.event.tiene_productos) {
                        this.pasoProductos = true;
                        this.pasoProductos_activo = true;
                        this.$nextTick(() => {
                            this.scrollTo('#pasoProductos');
                        });
                    } else {
                        this.paso1_activo = true;
                        this.puede_seleccionar = false;
                        this.$nextTick(() => {
                            this.scrollTo('#paso1', 600);
                        });
                    }
                }
            },
            productosListadoCombinacion() {
                for (let index = 0; index < this.productosListado.length; index++) {
                    const product = this.productosListado[index];
                    if (this.productos.find(item => item.item.id === product.item.id)) {
                        this.productos.find(item => item.item.id === product.item.id).units += product.units;
                    } else {
                        this.productos.push(product);
                    }
                }

                this.productosListado = [];
            },
            calcularTotalProductos() {
                if (!this.productos || this.productos.length === 0) {
                    return 0;
                }
                return this.productos.reduce((acc, producto) => {
                    const priceManagement = producto.item.price_management_interno === 0 ? Number(producto.item.price_management) : 0;
                    return acc + (producto.item.price * producto.units) + (priceManagement * producto.units);
                }, 0);
            },
            calcularTotalProductosSinManagement() {
                if (!this.productos || this.productos.length === 0) {
                    return 0;
                }
                return this.productos.reduce((acc, producto) => {
                    return acc + (producto.item.price * producto.units);
                }, 0);
            },
            handleValidNumber(isValid) {
                this.isValidNumber = isValid;

                if (isValid) {
                    this.guardarDatos();
                }
            }
        },
        components: {
            ResumenPrecioComponent,
            EntradasSinRecintoComponent,
            DatosEntradasSinRecinto,
            DatosCompradoresComponent,
            FormTerminos,
            CheckVoucherComponent,
            SendFacebookPetition,
            PagoPaycometComponent,
            ListadoProductosComponent,
            CarritoEvento,
            ResumenProductos
        }
    }
</script>

<style>
.fade-enter-active, .fade-leave-active {
    transition: opacity .2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.resize {
    font-size: 3rem !important;
}
@media (max-width: 768px) {
    .padding-mobile {
        padding-bottom: 12px;
    }
}
</style>
